import consts from './constants';
import moment from 'moment';

export default {

  /*
  * Init method for Library
  */
  G_init({ store, language, translate }) {
    consts.Context.STORE = store;
    consts.Context.TRANSLATE = translate;
    moment.locale(language);
    moment.defaultFormat = consts.Date.FORMAT;
  },

  G_changeLanguage(language) {
    moment.locale(language);
  },

  G_simpleFormatDate({ date }){
    if (date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hours = d.getHours(),
        mins = d.getMinutes();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        if (hours < 10) {
          hours = '0' + hours;
        }
        if (mins < 10) {
          mins = '0' + mins;
        }

        return [day, month, year].join('/') + ' ' + [hours, mins].join(':');
    }
  },

  G_simpleFormatDateOnly({ date, separator }){
    if (date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hours = d.getHours(),
        mins = d.getMinutes();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        let sep = separator ? separator : '/';

        return [day, month, year].join(sep);
    }
  },

  G_formatDate({ date, pretty, noHour, justHour, short }) {
    if (date) {
      const dateObj = new Date(date);

      if (pretty) {
        var days = moment().diff(dateObj, "days");
        if (days < 7) {
          pretty = true;
        } else {
          pretty = false;
        }
      }

      if (pretty) {
        let prettyDate = moment(dateObj).fromNow();
        return prettyDate.charAt(0).toUpperCase() + prettyDate.slice(1);
      } else {
        if (noHour) {
          return moment(dateObj).format(consts.Date.DATE);
        } else if (justHour) {
          return moment(dateObj).format(consts.Date.HOUR);
        } else if (short) {
          return moment(dateObj).format(consts.Date.SHORT_DATE);
        } else {
          return moment(dateObj).format();
        }
      }
    }
    return '';
  },

  G_isEmptyArr(arr) {
    return !arr || !arr.length;
  },

  G_getOrdinalSuffix(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  },

  G_canDo(action, user, enviroment) {
    user = JSON.parse(user);
    let result = false;
    switch (action) {
        case consts.Security.Action.VIEW_LOT_TAB:
          result = (consts.UserType.ADMIN === user.type_id ||
            consts.UserType.OPERATIONS === user.type_id || 
            consts.UserType.DEV_ADMIN === user.type_id || 
            consts.UserType.DEV_REAL_STATE === user.type_id);
          break;
        case consts.Security.Action.CREATE_LOT:
          result = (consts.UserType.ADMIN === user.type_id ||
              consts.UserType.OPERATIONS === user.type_id || 
              consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.UPDATE_LOT:
          result = (consts.UserType.ADMIN === user.type_id ||
              consts.UserType.OPERATIONS === user.type_id || 
              consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.EDIT_RESERVED_LOT:
          result = (consts.UserType.ADMIN === user.type_id ||
              consts.UserType.OPERATIONS === user.type_id || 
              consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.DELETE_LOT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_RESERVATION_TAB:
          result = (consts.UserType.ADMIN === user.type_id ||
            consts.UserType.OPERATIONS === user.type_id || 
            consts.UserType.DEV_ADMIN === user.type_id || 
            consts.UserType.DEV_SELLER === user.type_id || 
            consts.UserType.DEV_REAL_STATE === user.type_id);
          break;
        case consts.Security.Action.CREATE_RESERVATION:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id || 
                consts.UserType.DEV_SELLER == user.type_id || 
                consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.EDIT_RESERVATION:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id /*|| //TODO: Servicio para editar reservación 
                consts.UserType.DEV_ADMIN === user.type_id*/);
          break;
        case consts.Security.Action.CANCEL_RESERVATION:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.APPROVE_RESERVATION:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_LOG:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.CREATE_USER:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.UPDATE_USER:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.DELETE_USER:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_CUSTOMERS:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_USERS:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_AGENTS:
            result = (//consts.UserType.DEV_ADMIN === user.type_id || 
              //consts.UserType.DEV_SELLER === user.type_id || 
              consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.CREATE_AGENT:
            result = (//consts.UserType.DEV_ADMIN === user.type_id || 
              //consts.UserType.DEV_SELLER === user.type_id || 
              consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.UPDATE_AGENT:
            result = (//consts.UserType.DEV_ADMIN === user.type_id || 
              //consts.UserType.DEV_SELLER === user.type_id || 
              consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.DELETE_AGENT:
            result = (//consts.UserType.DEV_ADMIN === user.type_id || 
              //consts.UserType.DEV_SELLER === user.type_id || 
              consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.VIEW_REPORT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id || 
                consts.UserType.DEV_SELLER == user.type_id || 
                consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.VIEW_INVENTORY_REPORT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id || 
                consts.UserType.DEV_SELLER == user.type_id || 
                consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.VIEW_SALES_REPORT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id || 
                consts.UserType.DEV_SELLER == user.type_id || 
                consts.UserType.DEV_REAL_STATE == user.type_id);
          break;
        case consts.Security.Action.VIEW_VISITS_REPORT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        case consts.Security.Action.VIEW_HEAT_REPORT:
            result = (consts.UserType.ADMIN === user.type_id ||
                consts.UserType.OPERATIONS === user.type_id || 
                consts.UserType.DEV_ADMIN === user.type_id);
          break;
        
    }

    return result;
  },

  /**
   * Sort an array of objects by one object attribute
   * @param {*} arr 
   * @param {*} attribute 
   */
  G_sortArr(arr, attribute) {
    if (!this.G_isEmptyArr(arr)) {
      return arr.sort((a, b) => (a[attribute] && b[attribute]) ? a[attribute].localeCompare(b[attribute]) : 0);
    } else {
      return [];
    }
  },

  /**
   * Remove null attributes from object
   * @param {*} obj 
   */
  G_removeNullAttr(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj;
  },

  G_getDayOfWeek(timestamp) {
    return moment(timestamp * 1000).format('dddd')
  },

  G_renderPrice(price, currency) {
    price = parseFloat(price);
    return '$' + price.toLocaleString('en-US') + ' ' + currency;
  },

  G_renderName() {
    const user = JSON.parse(localStorage.getItem('user'));
    let name = user.first_name  + (user.last_name ? ' ' + user.last_name : '')
    return name;
  }

};
